import { render } from "./linkardInfoItem_Small.vue?vue&type=template&id=77ad27dc&scoped=true&ts=true"
import script from "./linkardInfoItem_Small.vue?vue&type=script&lang=ts"
export * from "./linkardInfoItem_Small.vue?vue&type=script&lang=ts"

import "./linkardInfoItem_Small.vue?vue&type=style&index=0&id=77ad27dc&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77ad27dc"]])

export default __exports__